<template>
  <div
    class="download-link tender-font underline pointer"
    @click="download"
  >
    {{ doc.filename }}
  </div>
</template>
<script>
import { downloadDocFile } from '@/utils/xfs'

export default {
  props: {
    doc: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    return {
      download: () => downloadDocFile(props.doc.id),
    }
  },
}
</script>
